export default __webpack_public_path__ + "static/media/19-LittleChurch.10468386.jpeg";